import {
  getToken,
} from '@/auth';

function getStatus() {
  return new Promise((resolve, reject) => {
    fetch('https://slack.com/api/users.profile.get?token=' + getToken())
      .then((response) => {
        response.json()
          .then((data) => {
            if (!data.ok || !data.profile) {
              reject('missing values from response');
              return;
            }
            const status = {
              emoji: data.profile.status_emoji,
              text: data.profile.status_text,
            };
            resolve(status);
          })
          .catch(error => reject(error));
      })
      .catch(error => reject(error));
  });
}

function writeStatus(status) {
  return new Promise((resolve, reject) => {
    const profile = {
      status_text: status.text,
      status_emoji: status.emoji,
    };
    fetch('https://slack.com/api/users.profile.set', {
      method: 'post',
      headers: {
        'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: 'token=' + getToken() + '&profile=' + encodeURIComponent(JSON.stringify(profile)),
    })
      .then(() => resolve())
      .catch(error => reject(error));
  });
}

const getChannels = async () => {
  const response = await fetch('https://slack.com/api/conversations.list?token=' + getToken() + '&types=public_channel,private_channel');
  const data = await response.json();
  return data.channels;
};

const sendMessage = async (channel, date, asUser, text) => {
  if (date < new Date()) {
    // eslint-disable-next-line no-alert
    alert('Cannot schedule message in the past.');
    return;
  }
  let body = `token=${getToken()}`;
  body = `${body}&as_user=${asUser ? 'true' : 'false'}`;
  body = `${body}&channel=${channel}`;
  body = `${body}&post_at=${Math.floor(date / 1000)}`;
  body = `${body}&text=${encodeURIComponent(text)}`;
  const response = await fetch('https://slack.com/api/chat.scheduleMessage', {
    method: 'post',
    headers: { 'Content-type': 'application/x-www-form-urlencoded' },
    body,
  });
  await response.json();
};

const deleteMessage = async (channelId, messageId) => {
  let body = `token=${getToken()}`;
  body = `${body}&channel=${channelId}`;
  body = `${body}&scheduled_message_id=${messageId}`;
  const response = await fetch('https://slack.com/api/chat.deleteScheduledMessage', {
    method: 'post',
    headers: { 'Content-type': 'application/x-www-form-urlencoded' },
    body,
  });
  await response.json();
};

const getScheduledMessages = async () => {
  const response = await fetch('https://slack.com/api/chat.scheduledMessages.list', {
    method: 'post',
    headers: { 'Content-type': 'application/x-www-form-urlencoded' },
    body: 'token=' + getToken(),
  });
  const data = await response.json();
  return data.scheduled_messages;
};

export {
  getStatus,
  writeStatus,
  getChannels,
  sendMessage,
  deleteMessage,
  getScheduledMessages,
};



// WEBPACK FOOTER //
// ./src/data/index.js